import React, { useRef, useEffect, useState } from 'react';
import { useCountUp } from 'react-countup';
import { gsap } from 'gsap';
import './Statistics.scss';

function Statistics() {
  const barRef = useRef();
  const [showCounter, setShowCounter] = useState(false);

  useEffect(() => {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: barRef.current,
        start: 'top 75%',
        end: 'top 75%',
        once: true,
        onEnter: () => {
          setShowCounter(true);
        }
      }
    });
    tl.to('#bar76', { width: '76%', duration: 1.2 }).to(
      '#bar82',
      { width: '79%', duration: 1.2 },
      '-=1.2'
    );
  }, []);

  const SimpleHook = () => {
    useCountUp({
      ref: 'counter',
      end: 76,
      start: 0,
      duration: 1.2
    });
    return <span id="counter" />;
  };
  const SimpleHook2 = () => {
    useCountUp({
      ref: 'counter2',
      end: 79,
      start: 0,
      duration: 1.2
    });
    return <span id="counter2" />;
  };

  return (
    <figure className="statistics">
      <div className="statistics__graphic">
        <h3 className="statistics__graphic__title">
          The enduring popularity of detached single-family homes
        </h3>
        <div className="statistics__graphic__graph" ref={barRef}>
          <p className="statistics__graphic__graph__copy year">1981</p>
          <div className="bar">
            <div className="bar-left bar-left-76" id="bar76" />

            <p className="bar-number" id="num76">
              {showCounter ? <SimpleHook /> : `0`}%
            </p>
          </div>
          <p className="statistics__graphic__graph__copy">
            of home buyers purchased detached single-family homes
          </p>
        </div>

        <div className="statistics__graphic__graph">
          <p className="statistics__graphic__graph__copy year">2022</p>
          <div className="bar">
            <div className="bar-left bar-left-82" id="bar82" />
            <p className="bar-number " id="num82">
              {showCounter ? <SimpleHook2 /> : `0`}%
            </p>
          </div>
          <p className="statistics__graphic__graph__copy">
            of home buyers purchased detached single-family homes
          </p>
        </div>
      </div>
      <figcaption className="captions">
        Source: NAR, Profile of Home Buyers and Sellers, 2022
      </figcaption>
    </figure>
  );
}

export default Statistics;
